<app-page-meta pageTitle="Peer to Peer (P2P) Lending India | Quick and Easy P2P Loans | P2P Lenders"
               tags="peer to peer lending, investment online, low risk investments, safe investments, alternate investments, easy investments, p2p lending, investments in India, private money lenders, lending money, online lenders, p2p lender, p2p loans, online lending india, investment opportunities, peer to peer lending India, quick personal loans, low interest personal loans, easy loans online"
               description="P2P lending is predominantly an online business in which individual and institutional investors provide funding to people seeking loans. Finzy is India's most trusted Peer to Peer lending Platform. Apply online for quick and easy P2P loans in India and also sign up to be a part of best P2P lenders community.">
</app-page-meta>

<app-article>

  <div class="title">Peer to Peer (P2P) lending in India</div>

  <span class="timestamp">June 26, 2018</span>

  <div class="content">
    <section>
      <h2 class="subheading">What is peer to peer lending</h2>
      <p>As per Reserve Bank of India's definition:
        <br>
        <b>Peer to peer lending (P2P)</b> is a form of crowd-funding used to raise loans which are paid back with
        interest. It can be defined as the use of an online platform that matches peer lenders with borrowers in order
        to
        provide unsecured loans. P2P lending is predominantly an online business in which individual and institutional
        investors provide funding to people seeking loans.</p>

      <p>Lenders invest in qualified borrowers who are looking for a loan and the peer lending (P2P) platform
        facilitates this match-making.</p>

      <p>Finzy was the first peer to peer lending company in India to have applied for the P2P NBFC license.</p>
    </section>

    <section>
      <h2 class="subheading">The P2P Lending Value Proposition</h2>

      <p>The P2P platform helps provide a new asset class to lenders that enables them to get higher returns compared to
        other asset classes. They also stand to earn regular monthly returns from their investments, in form of EMIs
        that
        the borrowers repay.</p>

      <p>In addition to the steady cash flows that the P2P platform provides, reinvesting this inflow back into the P2P
        platform or into other asset classes allows the lender to earn greater returns from the lender's original
        investment. Finzy helps optimise risk of investing in P2P loans by ensuring that the investments are diversified
        across at least 5 loans using a proprietary algorithm.</p>

      <p>Borrowers have access to credit online at relatively low interest rates, with ease of loan application and
        quick turn-around times for disbursal.</p>

      <p>Finzy also provides features such as no lock-in period and no prepayment charges that makes applying for a P2P
        loan very attractive to the borrower.</p>

      <p>P2P platforms are tech platforms that use technology to provide greater security of information (as compared to
        traditional paper based systems) and better user experience to both borrowers and lenders.</p>

      <p>At finzy, both borrowers and investors have access to their dashboard online that helps them track their
        payments
        and dues in an easy and transparent manner.</p>
    </section>

    <section>
      <h2 class="subheading">Who Can Invest And Borrow on a P2P Lending Platform</h2>
      <p>To register on the platform a lender or a borrower needs to be an Indian citizen, over 18 years of age. With
        necessary KYC documents for Proof of Identity (eg. PAN) and Proof of Address (eg. Aadhaar)</p>

      <p>To avail a P2P loan, the borrower can either be an individual or a legal person requiring a loan.
        At finzy, presently we offer loans to individuals who could be salaried or self-employed.</p>

      <p>The interest rate may be set by the platform, or by mutual agreement between the borrower and the lender. At
        finzy, we help set the interest rate based on the credit assessment done by the platform.</p>

      <p>At the moment RBI limits the maximum investment amount to INR 50 lakhs for a lender across P2P platforms.</p>
    </section>

    <section>
      <h2 class="subheading">How Does the P2P Lending Platform Earn Revenue</h2>
      <p>Fees are paid to the platform by both the lender as well as the borrower. The borrowers pay an origination fee
        (either a flat rate fee or as a percentage of the loan amount raised) according to their risk category. Read
        more about fees at finzy <a href="/faq?selectedTab=pricing">here</a>.</p>

      <p>At finzy, we only take a small fee (2% + GST) of the EMI that the investors receive.
        There are no other charges for registration, documentation, assessment or any other hidden charges at finzy for
        both the borrowers and lenders.</p>

      <p>Since a peer lending platform is not allowed to lend money from its books, there is no conflict of interest and
        the entire process is transparent and the EMI that the borrower pays is handed over as is to the investors. The
        lower cost structure associated with online originations enables P2P platforms to offer borrowers attractive
        rates.</p>
    </section>

    <section>
      <h2 class="subheading">P2P Lending in India: By the numbers</h2>
      <p>P2P lending is a new wave and is taking off in India. It is finding favour with borrowers - especially those
        who
        want a hassle free borrowing experience at competitive interest rates and with lenders who wish to invest their
        money in a completely new asset class with higher returns.</p>

      <p>P2P platforms offer borrowers an improved borrowing experience. Platform-based borrowing will invariably gain
        huge momentum over the next three to five years due to competitive interest rates and ease of making finance
        available.</p>

      <p>Although P2P lending is still in its infancy as a market, but the demand is on a rise and is expected to grow
        to
        150 billion USD by 2025. The estimated P2P lending to be generated in India over the next five years is pegged
        at
        around 4 Billion USD.</p>

      <p>Consumers were hungry for a simplified, streamlined lending process. P2P firms are capitalizing on this need.
        P2P
        lending has already begun its expansion beyond simple loans largely used by consumers to consolidate credit card
        debt.</p>

      <p>The P2P industry in India was regulated by RBI in October 2017, you can read the RBI guidelines for the
        industry <a href="https://www.rbi.org.in/Scripts/NotificationUser.aspx?Id=11137" rel="nofollow" target="_blank">here</a>.
      </p>
    </section>

    <section>
      <h2 class="subheading">How peer to peer lending works at finzy</h2>
      Finzy makes the entire investment process simple and user friendly. You can create your portfolio in a couple of
      minutes:
      <ol>
        <li>Register yourself and submit your KYC documents.</li>
        <li>Select borrowers manually or use “finzyPRO+” to create your portfolio.</li>
        <li>Invest your funds through a prepaid offline wallet or through a secured online payment gateway.</li>
      </ol>
    </section>

    <section>
      <h2 class="subheading">Why Invest in Finzy</h2>
      <p>At finzy, we take care of your trust by assigning a deserving credit rating to each borrower that you can
        invest in and helping you with investment, documentation, monthly collections, account reconciliation and
        recovery. Therefore, we support you at every step.</p>
    </section>

    <section>
      <h2 class="subheading">P2P and taxes</h2>
      <p>The interest income you earn from P2P lending is taxable, but the platform provides you the entire returns
        without
        tax being deducted. Finzy helps lenders avail a provisional interest certificate through the financial year and
        a
        final interest certificate at the end of the financial year to help them plan their taxes.</p>
    </section>

    <section>
      <h2 class="subheading">Other Services That the Peer Lending Platform Provides</h2>
      <p>The platform provides the service of collecting P2P loan repayments and doing a preliminary assessment on the
        borrower's creditworthiness.</p>

      <p>At finzy we have a proprietary credit algorithm that looks at 130 parameters of the borrower to assess the loan
        application. The assessment is not limited just to the credit score (CIBIL score) or the category of company but
        takes into account all 130 parameters that include social media activity, demographic information, income
        details, employment details and the like.</p>

      <p>The platforms do the credit scoring and make a profit from arrangement fees and not from the spread between
        lending
        and deposit rates as is the case with normal financial intermediation.</p>

      <p>The platform also facilitates the documentation needed to disburse the loan. Finzy handles the entire
        documentation
        process between the lenders and the borrowers to ensure that the legal aspects are handled and the experience is
        hassle free for both borrower and lenders.</p>

      <p>The platform provides a service for EMI collection that seamlessly collects the EMI due from the borrower and
        provides the returns to the relevant investors on a monthly basis.</p>

      <p>Finzy also helps in the recovery process for any loans that may have been delayed or defaulted. We have a
        collections team in place that helps borrowers regularise any delayed loans. We also have a legal team to help
        with
        legal recourse to be taken if necessary.</p>

      <p>With the benefits that the P2P platform provides to both borrowers and investors, Finzy is pushing the
        boundaries
        of Peer to Peer Lending in India. Try us out today!</p>
    </section>
  </div>

</app-article>
